<div *ngIf="(viewMode ==='image')" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-10">
    <ng-container *ngFor="let item of sanitizedItems">
        <a [routerLink]="['/item-details-bc', 'item', item.itemId]" class="block bg-white rounded-lg p-4 mx-auto  max-w-[333px] md:mt-4
       border border-black/5
       shadow-md">
            <!-- IMAGE + OVERLAYS -->
            <div class="relative w-full aspect-[4/3] overflow-hidden rounded-t-xl">
                <img [src]="absoluteMediaUriService.getAbsoluteMediaUri(item.imageUrl, 'item-default.jpg')" [alt]="item.safeName"
                    class="w-full h-full object-cover" loading="lazy" />

                <!-- Favorite ribbon (upper-right) -->
                <button type="button" (click)="toggleFavorite(item); $event.preventDefault(); $event.stopPropagation();"
                    class="absolute top-0 right-0 z-10
         grid place-items-center
         w-8 h-8 rounded-full
         bg-white/80 backdrop-blur-sm
         border border-black/10
         shadow-md
         transition hover:scale-105 hover:bg-white" aria-label="Toggle favorite">
                    <fa-icon [icon]="item.isFavorite ? faBookmarkSolid : faBookmarkRegular"
                        class="text-blue-600 text-base"></fa-icon>
                </button>
            </div>

            <!-- TEXT -->
            <div class="p-4">
                <h3 class="text-xl font-noto-serif text-[var(--dark-teal)] font-bold" [innerHTML]="item.safeName">
                </h3>

                <p class="mt-2 text-gray-700">
                    <span class="text-[18px] font-semibold  text-custom-black">
                        {{ (item.isBuyable ? item.buyNowPrice : item.currentLeadingBid) | currency}}
                    </span>
                    <span class="text-[var(--sky-blue)]  font-semibold ml-2">
                        {{
                        item.isBiddable
                        ? (item.numberOfBids === 0 ? 'Opening Bid' : 'Leading Bid')
                        : (item.isBuyable ? 'Buy Now' : 'Leading Bid')
                        }}
                    </span>
                </p>

                <!-- Optional org name line like in comp -->
                <p class="mt-1 text-[var(--fs-dark)] uppercase ">
                    {{ item.orgName }}
                </p>
            </div>

            <div class=" ml-2 px-1">

                <button pButton type="button" class=" h-[35px]  w-full  rounded-md flex items-center justify-center "
                    [routerLink]="['/item-detals-bc', 'item', item.itemId]">
                    <span class=" !text-[var(--p-text-color-secondary)] text-center w-ful font-noto-serif">
                        @if (item.currentLeadingBid! > 0) {
                        <span>Place a Bid</span>
                        } @else if (item.buyNowPrice) {
                        <span>Buy Now</span>
                        } @else {
                        <span>See More</span>
                        }
                    </span>
                </button>
            </div>
        </a>
    </ng-container>

</div>

<div *ngIf="(viewMode === 'list')">
    <div class="flex flex-col w-full gap-4">
        <div *ngFor="let item of sanitizedItems"
            class="w-full bg-white rounded-lg overflow-hidden border-b border-gray-300 flex items-center p-4 justify-between cursor-pointer hover:bg-gray-50"
            [routerLink]="['/item-details-bc', 'item', item.itemId]" tabindex="0" role="button"
            [attr.aria-label]="item.safeName">
            <div class="w-24 h-24">
                <img [src]="item.imageUrl" [alt]="item.safeName" class="w-full h-full object-cover rounded-lg">
            </div>

            <div class="flex flex-col pl-4 w-1/3">
                <p class=" text-[var(--charcoal)]">{{ category }}</p>
                <div class="flex items-center">
                    <h3 class="text-[var(--dark-teal)]  font-noto-serif text-xl font-bold" [innerHTML]="item.safeName">
                    </h3>

                    <!-- stop row click from firing when toggling favorite -->
                    <fa-icon [icon]="item.isFavorite ? faBookmarkSolid : faBookmarkRegular" class="ml-4 text-2xl text-blue-300 cursor-pointer
         transition hover:scale-105 hover:bg-white" (click)="toggleFavorite(item); $event.stopPropagation()">
                    </fa-icon>
                </div>

            </div>

            <div class="flex-1 flex flex-col justify-center text-left w-1/3">
                <p class="mt-1">
                    <span class="text-lg font-bold text-custom-black">
                        {{ (item.isBuyable ? item.buyNowPrice : item.currentLeadingBid) | currency}}
                    </span>
                    <span class="text-[var(--sky-blue)]  font-semibold ml-2">
                        {{
                        item?.currentLeadingBid! > 0
                        ? (item?.numberOfBids! > 0 ? 'Leading Bid' : 'Opening Bid')
                        : (item?.buyNowPrice! > 0 && item?.numberOfBids! === 0 ? 'Buy Now' : 'Leading Bid')
                        }}
                    </span>
                </p>
                <p>
                    <span *ngIf="item.estimatedValue; else noEstimatedValue" class="text-[#6E6E6E] text-sm">
                        {{ isAmountEstimatedValue(item.estimatedValue.toString()) ? (item.estimatedValue | currency ) +
                        ' Estimated
                        Value':
                        'Priceless' }}
                    </span>
                    <ng-template #noEstimatedValue>
                        <span class="text-gray-500 text-xs invisible"></span>
                    </ng-template>
                </p>
            </div>

            <div class="flex flex-col items-center w-80 space-y-3">
                <button pButton
                    class="lg:h-[35px]  w-full relative flex items-center justify-center rounded-lg">
                    <fa-icon [icon]="faCreditCard" class="ml-2"></fa-icon>
                    <span class=" text-white text-center w-full font-noto-serif">
                        @if (item.currentLeadingBid) {
                        <span>Place a Bid</span>
                        } @else if (item.buyNowPrice) {
                        <span>Buy Now</span>
                        } @else {
                        <span>See More</span>
                        }
                    </span>
                </button>
                <div class="text-center mt-2">
                    <p class="h-5 text-black  font-medium text-sm italic">
                        {{ timeLeftService.getTimeLeft(item.openingDate, item.closingDate) }}

                    </p>
                </div>
            </div>
        </div>
    </div>
</div>